import { render, staticRenderFns } from "./tobuy.vue?vue&type=template&id=3cb212a0&scoped=true&"
import script from "./tobuy.vue?vue&type=script&lang=js&"
export * from "./tobuy.vue?vue&type=script&lang=js&"
import style0 from "./tobuy.vue?vue&type=style&index=0&id=3cb212a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb212a0",
  null
  
)

export default component.exports